// frontend/src/admin/components/AdminLayout.js - LAYOUT PRINCIPAL ADMIN
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import AdminDashboard from '../pages/AdminDashboard';
import UserManagement from '../pages/UserManagement';
import PaymentMonitoring from '../pages/PaymentMonitoring';
import SystemMonitoring from '../pages/SystemMonitoring';
import AIUsageMonitoring from '../pages/AIUsageMonitoring';
import SupportTickets from '../pages/SupportTickets';
import AdminFiscal from '../pages/AdminFiscal';

import '../styles/AdminGlobal.css';

// ✅ IMPORTANT : on utilise maintenant le client Axios commun
import api from '../../services/api';

const AdminLayout = ({ adminUser }) => {
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [liveStats, setLiveStats] = useState(null);
  const [loadingLive, setLoadingLive] = useState(true);
  const [liveError, setLiveError] = useState(null);

  // ==========================
  // LOGOUT
  // ==========================
  const handleLogout = () => {
    console.log('🚪 Déconnexion admin...');

    // supprimer session
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    // supprimer remember me si présent
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('rememberEmail');
    localStorage.removeItem('rememberPassword');

    // fermer sidebar
    setSidebarOpen(false);

    // redirection login
    navigate('/login', { replace: true });
  };

  // ==========================
  // CHARGER LES STATS LIVE ADMIN
  // ==========================
  const fetchLiveStats = async () => {
    try {
      setLiveError(null);
      const response = await api.get('/admin/dashboard/live');
      const data = response.data;

      if (data && data.success) {
        setLiveStats(data.stats || data);
      } else {
        console.error('❌ Erreur API live stats:', data?.message);
        setLiveError(data?.message || 'Erreur API');
      }
    } catch (error) {
      console.error('❌ Erreur récupération stats live:', error);
      setLiveError(error.message || 'Erreur réseau');
    } finally {
      setLoadingLive(false);
    }
  };

  useEffect(() => {
    fetchLiveStats();
    const interval = setInterval(fetchLiveStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handlePageChange = (pageKey) => {
    setCurrentPage(pageKey);
  };

  return (
    <div className={`admin-layout ${sidebarOpen ? 'admin-layout--sidebar-open' : ''}`}>
      {/* Sidebar */}
      <AdminSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onToggle={toggleSidebar}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        adminUser={adminUser}
        liveStats={liveStats}
      />

      {/* Contenu principal */}
      <div className="admin-main">
        <AdminHeader
          // ⚠️ ton AdminHeader utilise onMenuClick (dans la version qu’on a corrigée)
          onMenuClick={toggleSidebar}
          adminUser={adminUser}
          liveStats={liveStats}
          loadingLive={loadingLive}
          liveError={liveError}
          onLogout={handleLogout} // ✅ C’EST ÇA QUI MANQUAIT
        />

        <div className="admin-main__content">
          <Routes>
            <Route
              path="/"
              element={
                <AdminDashboard
                  adminUser={adminUser}
                  liveStats={liveStats}
                  onPageChange={handlePageChange}
                />
              }
            />

            <Route
              path="/users"
              element={<UserManagement adminUser={adminUser} onPageChange={handlePageChange} />}
            />

            <Route
              path="/support"
              element={<SupportTickets adminUser={adminUser} onPageChange={handlePageChange} />}
            />

            <Route
              path="/payments"
              element={<PaymentMonitoring adminUser={adminUser} onPageChange={handlePageChange} />}
            />

            <Route
              path="/system"
              element={<SystemMonitoring adminUser={adminUser} onPageChange={handlePageChange} />}
            />

            <Route
              path="/ai-usage"
              element={<AIUsageMonitoring adminUser={adminUser} onPageChange={handlePageChange} />}
            />

            <Route
              path="/fiscal"
              element={<AdminFiscal adminUser={adminUser} onPageChange={handlePageChange} />}
            />

            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </div>
      </div>

      {/* Overlay mobile */}
      {sidebarOpen && (
        <div className="admin-overlay" onClick={() => setSidebarOpen(false)} />
      )}
    </div>
  );
};

export default AdminLayout;
